// src/pages/usa/puertorico/PuertoRico.js
import "../../../App.css";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";

import BackSearchGo from "../../../components/BackSearchGo";
import ContactPopup from "../../../components/ContactPopup";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function PuertoRico() {
  const navigate = useNavigate();

  // ⭐ Popup state — required for opening/closing the popup
  const [open, setOpen] = useState(false);

  // ⭐ Puerto Rico places — alphabetical
  const places = [
    { name: "Adjuntas", visited: true, page: "/travel/puertorico/adjuntas" },
    { name: "Aguada", visited: true, page: "/travel/puertorico/aguada" },
    { name: "Aguadilla", visited: true, page: "/travel/puertorico/aguadilla" },
    { name: "Aguas Buenas", visited: false },
    { name: "Aibonito", visited: false },
    { name: "Añasco", visited: true, page: "/travel/puertorico/anasco" },
    { name: "Arecibo", visited: true, page: "/travel/puertorico/arecibo" },
    { name: "Arroyo", visited: false },
    { name: "Barceloneta", visited: false },
    { name: "Barranquitas", visited: false },
    { name: "Bayamón", visited: false },
    { name: "Cabo Rojo", visited: true, page: "/travel/puertorico/caborojo" },
    { name: "Caguas", visited: false },
    { name: "Camuy", visited: false },
    { name: "Canóvanas", visited: false },
    { name: "Carolina", visited: false },
    { name: "Cataño", visited: false },
    { name: "Cayey", visited: false },
    { name: "Ceiba", visited: false },
    { name: "Ciales", visited: false },
    { name: "Cidra", visited: false },
    { name: "Coamo", visited: false },
    { name: "Comerío", visited: false },
    { name: "Corozal", visited: false },
    { name: "Culebra", visited: false },
    { name: "Dorado", visited: false },
    { name: "Fajardo", visited: false },
    { name: "Florida", visited: false },
    { name: "Guánica", visited: true, page: "/travel/puertorico/guanica" },
    { name: "Guayama", visited: false },
    { name: "Guayanilla", visited: false },
    { name: "Guaynabo", visited: false },
    { name: "Gurabo", visited: false },
    { name: "Humacao", visited: false },
    { name: "Isabela", visited: true, page: "/travel/puertorico/isabela" },
    { name: "Jayuya", visited: true, page: "/travel/puertorico/jayuya" },
    { name: "Juana Díaz", visited: false },
    { name: "Juncos", visited: false },
    { name: "Lajas", visited: true, page: "/travel/puertorico/lajas" },
    { name: "Lares", visited: false },
    { name: "Las Marías", visited: false },
    { name: "Las Piedras", visited: false },
    { name: "Loíza", visited: false },
    { name: "Luquillo", visited: false },
    { name: "Manatí", visited: false },
    { name: "Maricao", visited: false },
    { name: "Maunabo", visited: false },
    { name: "Moca", visited: false },
    { name: "Morovis", visited: false },
    { name: "Naguabo", visited: false },
    { name: "Naranjito", visited: false },
    { name: "Orocovis", visited: false },
    { name: "Patillas", visited: false },
    { name: "Peñuelas", visited: false },
    { name: "Ponce", visited: false },
    { name: "Quebradillas", visited: false },
    { name: "Rincón", visited: true, page: "/travel/puertorico/rincon" },
    { name: "Río Grande", visited: false },
    { name: "Sabana Grande", visited: false },
    { name: "Salinas", visited: false },
    { name: "San Germán", visited: false },
    { name: "San Juan", visited: true, page: "/travel/puertorico/sanjuan" },
    { name: "San Lorenzo", visited: false },
    { name: "San Sebastián", visited: false },
    { name: "Santa Isabel", visited: false },
    { name: "Toa Alta", visited: false },
    { name: "Toa Baja", visited: false },
    { name: "Trujillo Alto", visited: false },
    { name: "Utuado", visited: true, page: "/travel/puertorico/utuado" },
    { name: "Vega Alta", visited: false },
    { name: "Vega Baja", visited: false },
    { name: "Vieques", visited: false, page: "/travel/puertorico/vieques" },
    { name: "Villalba", visited: false },
    { name: "Yabucoa", visited: false },
    { name: "Yauco", visited: false }
  ];

  return (
    <>
      <Header />

      <div
        className="usa-container colorado-page"
        style={{
          backgroundImage: "url('/images/usa/puertorico/PuertoRico.png')",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          minHeight: "100vh",
          paddingTop: "0px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center"
        }}
      >

        {/* ⭐ Back / Search / Go — wrapped for top positioning */}
        <div className="searchbar-top-container">
          <BackSearchGo onBack={() => navigate("/usa")} />
        </div>

        {/* ⭐ Legend */}
        <div className="legend" style={{ marginBottom: "20px" }}>
          <span className="legend-blue">Blue = Visited Places</span>
          <span className="legend-green">Green = Places To Visit</span>
        </div>

        {/* ⭐ 3‑column grid */}
        <div className="colorado-grid-3">
          {places.map((p) => (
            <div
              key={p.name}
              className={`place ${p.visited ? "visited" : "to-visit"}`}
              onClick={() => p.visited && navigate(p.page)}
              style={{ cursor: p.visited ? "pointer" : "default" }}
            >
              {p.name}
            </div>
          ))}
        </div>
      </div>

      {/* Centered email button */}
      <div className="email-wrapper">
        <button
          className="email-link"
          onClick={() => setOpen(true)}
        >
          contact@thefindingspot.com
        </button>
      </div>

      {/* Popup */}
      <ContactPopup
        isOpen={open}
        onClose={() => setOpen(false)}
      />

      <Footer />
    </>
  );
}
